module.exports = __webpack_public_path__ + "static/default-header-structure-96ec1895d49c92d2f2da3f6be1c127ad.jpg";